/* tslint:disable */
/* eslint-disable */
/**
 * vestniky Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CreateUpdatePrispevok
 */
export interface CreateUpdatePrispevok {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePrispevok
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePrispevok
     */
    'vestnikUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePrispevok
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePrispevok
     */
    'kratkyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePrispevok
     */
    'cislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePrispevok
     */
    'datumZverejnenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePrispevok
     */
    'datumUcinnosti'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePrispevok
     */
    'popis'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdatePrispevok
     */
    'meniPrispevky'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdatePrispevok
     */
    'rusiPrispevky'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdatePrispevok
     */
    'vykonavaciePredpisy'?: Array<string>;
    /**
     * 
     * @type {Array<Priloha>}
     * @memberof CreateUpdatePrispevok
     */
    'prilohy'?: Array<Priloha>;
    /**
     * 
     * @type {PrispevokVestnikaStepEnum}
     * @memberof CreateUpdatePrispevok
     */
    'activeStep'?: PrispevokVestnikaStepEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OpravnenieEnum = {
    Verejnost: 'VEREJNOST',
    Pripomienkovatel: 'PRIPOMIENKOVATEL',
    Vyhodnocovatel: 'VYHODNOCOVATEL',
    Odosielatel: 'ODOSIELATEL',
    Anonymous: 'ANONYMOUS',
    Superadmin: 'SUPERADMIN',
    NelegislativnaOrganizacia: 'NELEGISLATIVNA_ORGANIZACIA',
    PredkladatelLeg: 'PREDKLADATEL_LEG',
    PredkladatelNeleg: 'PREDKLADATEL_NELEG',
    PredkladatelZodp: 'PREDKLADATEL_ZODP',
    AktyEu: 'AKTY_EU',
    AktyEuSpravca: 'AKTY_EU_SPRAVCA',
    Clen: 'CLEN',
    SchvalovatelVlada: 'SCHVALOVATEL_VLADA',
    Spracovatel: 'SPRACOVATEL',
    VeduciOrganizacie: 'VEDUCI_ORGANIZACIE',
    VyhlasovatelPortal: 'VYHLASOVATEL_PORTAL',
    RezortneZbierkyImport: 'REZORTNE_ZBIERKY_IMPORT',
    RezortneZbierkySpravca: 'REZORTNE_ZBIERKY_SPRAVCA',
    AdministratorTezaurus: 'ADMINISTRATOR_TEZAURUS',
    RedaktorTezaurus: 'REDAKTOR_TEZAURUS',
    SudneRozhodnutiaEuSpravca: 'SUDNE_ROZHODNUTIA_EU_SPRAVCA'
} as const;

export type OpravnenieEnum = typeof OpravnenieEnum[keyof typeof OpravnenieEnum];


/**
 * 
 * @export
 * @interface Organizacia
 */
export interface Organizacia {
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'nazov': string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'skratenyNazov'?: string;
}
/**
 * 
 * @export
 * @interface Page
 */
export interface Page {
    /**
     * total count of elements
     * @type {number}
     * @memberof Page
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof Page
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof Page
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface Priloha
 */
export interface Priloha {
    /**
     * 
     * @type {string}
     * @memberof Priloha
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Priloha
     */
    'originalFilename'?: string;
    /**
     * 
     * @type {number}
     * @memberof Priloha
     */
    'fileSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof Priloha
     */
    'dmsId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Priloha
     */
    'nazovSuboru'?: string;
    /**
     * 
     * @type {string}
     * @memberof Priloha
     */
    'subor'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Priloha
     */
    'hlavna'?: boolean;
}
/**
 * 
 * @export
 * @interface PrilohaVestnika
 */
export interface PrilohaVestnika {
    /**
     * 
     * @type {string}
     * @memberof PrilohaVestnika
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrilohaVestnika
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrilohaVestnika
     */
    'fileS3Path'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PrilohaVestnika
     */
    'hlavna'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PrilohaVestnika
     */
    'originalFilename'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrilohaVestnika
     */
    'fileSize'?: number;
}
/**
 * 
 * @export
 * @interface PrispevokVestnika
 */
export interface PrispevokVestnika {
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnika
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnika
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnika
     */
    'kratkyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnika
     */
    'cislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnika
     */
    'datumZverejnenia'?: string;
    /**
     * 
     * @type {Organizacia}
     * @memberof PrispevokVestnika
     */
    'vestnik'?: Organizacia;
}
/**
 * 
 * @export
 * @interface PrispevokVestnikaDetail
 */
export interface PrispevokVestnikaDetail {
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaDetail
     */
    'uuid': string;
    /**
     * 
     * @type {Organizacia}
     * @memberof PrispevokVestnikaDetail
     */
    'vestnik'?: Organizacia;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaDetail
     */
    'cislo': string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaDetail
     */
    'datumZverejnenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaDetail
     */
    'datumUcinnosti'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaDetail
     */
    'kratkyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaDetail
     */
    'nazov': string;
    /**
     * 
     * @type {Array<PrispevokVestnika>}
     * @memberof PrispevokVestnikaDetail
     */
    'meniPrispevky'?: Array<PrispevokVestnika>;
    /**
     * 
     * @type {Array<PrispevokVestnika>}
     * @memberof PrispevokVestnikaDetail
     */
    'rusiPrispevky'?: Array<PrispevokVestnika>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrispevokVestnikaDetail
     */
    'vykonavaciePredpisy'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaDetail
     */
    'popis'?: string;
    /**
     * 
     * @type {Array<PrilohaVestnika>}
     * @memberof PrispevokVestnikaDetail
     */
    'prilohy'?: Array<PrilohaVestnika>;
}
/**
 * 
 * @export
 * @interface PrispevokVestnikaFilter
 */
export interface PrispevokVestnikaFilter {
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaFilter
     */
    'vestnikUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaFilter
     */
    'hladanyVyraz'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaFilter
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaFilter
     */
    'cislo'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrispevokVestnikaFilter
     */
    'datumZverejneniaRok'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaFilter
     */
    'datumUcinnostiOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaFilter
     */
    'datumUcinnostiDo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaFilter
     */
    'datumZverejneniaOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaFilter
     */
    'datumZverejneniaDo'?: string;
}
/**
 * 
 * @export
 * @interface PrispevokVestnikaInfo
 */
export interface PrispevokVestnikaInfo {
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaInfo
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaInfo
     */
    'vestnikUuid': string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaInfo
     */
    'cislo': string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaInfo
     */
    'kratkyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaInfo
     */
    'nazov': string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaInfo
     */
    'datumZverejnenia': string;
}
/**
 * 
 * @export
 * @interface PrispevokVestnikaListItem
 */
export interface PrispevokVestnikaListItem {
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaListItem
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaListItem
     */
    'vestnikUuid': string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaListItem
     */
    'cislo': string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaListItem
     */
    'kratkyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaListItem
     */
    'nazov': string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaListItem
     */
    'datumZverejnenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrispevokVestnikaListItem
     */
    'datumUcinnosti'?: string;
}
/**
 * 
 * @export
 * @interface PrispevokVestnikaListPage
 */
export interface PrispevokVestnikaListPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof PrispevokVestnikaListPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof PrispevokVestnikaListPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof PrispevokVestnikaListPage
     */
    'size': number;
    /**
     * 
     * @type {Array<PrispevokVestnikaListItem>}
     * @memberof PrispevokVestnikaListPage
     */
    'prispevokVestnikaList'?: Array<PrispevokVestnikaListItem>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PrispevokVestnikaStepEnum = {
    BasicData1: 'BASIC_DATA_1',
    Dates2: 'DATES_2',
    RelatedData3: 'RELATED_DATA_3',
    Attachments4: 'ATTACHMENTS_4',
    MainAttachment5: 'MAIN_ATTACHMENT_5'
} as const;

export type PrispevokVestnikaStepEnum = typeof PrispevokVestnikaStepEnum[keyof typeof PrispevokVestnikaStepEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortDirectionEnum = typeof SortDirectionEnum[keyof typeof SortDirectionEnum];


/**
 * 
 * @export
 * @interface UserDetail
 */
export interface UserDetail {
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'meno'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'organizaciaUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'organizaciaCiselnikyUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'organizaciaNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'organizaciaSkratka'?: string;
    /**
     * 
     * @type {Array<OpravnenieEnum>}
     * @memberof UserDetail
     */
    'opravnenieList'?: Array<OpravnenieEnum>;
}

/**
 * PrispevokVestnikaAddApi - axios parameter creator
 * @export
 */
export const PrispevokVestnikaAddApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add prispevok vestnika
         * @param {CreateUpdatePrispevok} createUpdatePrispevok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPrispevokVestnika: async (createUpdatePrispevok: CreateUpdatePrispevok, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUpdatePrispevok' is not null or undefined
            assertParamExists('addPrispevokVestnika', 'createUpdatePrispevok', createUpdatePrispevok)
            const localVarPath = `/prispevok-vestnika`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUpdatePrispevok, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate prispevok vestnika in active step before create/update.
         * @param {CreateUpdatePrispevok} createUpdatePrispevok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePrispevokVestnika: async (createUpdatePrispevok: CreateUpdatePrispevok, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUpdatePrispevok' is not null or undefined
            assertParamExists('validatePrispevokVestnika', 'createUpdatePrispevok', createUpdatePrispevok)
            const localVarPath = `/prispevok-vestnika`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUpdatePrispevok, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrispevokVestnikaAddApi - functional programming interface
 * @export
 */
export const PrispevokVestnikaAddApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrispevokVestnikaAddApiAxiosParamCreator(configuration)
    return {
        /**
         * Add prispevok vestnika
         * @param {CreateUpdatePrispevok} createUpdatePrispevok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPrispevokVestnika(createUpdatePrispevok: CreateUpdatePrispevok, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPrispevokVestnika(createUpdatePrispevok, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrispevokVestnikaAddApi.addPrispevokVestnika']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate prispevok vestnika in active step before create/update.
         * @param {CreateUpdatePrispevok} createUpdatePrispevok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePrispevokVestnika(createUpdatePrispevok: CreateUpdatePrispevok, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePrispevokVestnika(createUpdatePrispevok, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrispevokVestnikaAddApi.validatePrispevokVestnika']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrispevokVestnikaAddApi - factory interface
 * @export
 */
export const PrispevokVestnikaAddApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrispevokVestnikaAddApiFp(configuration)
    return {
        /**
         * Add prispevok vestnika
         * @param {CreateUpdatePrispevok} createUpdatePrispevok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPrispevokVestnika(createUpdatePrispevok: CreateUpdatePrispevok, options?: any): AxiosPromise<string> {
            return localVarFp.addPrispevokVestnika(createUpdatePrispevok, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate prispevok vestnika in active step before create/update.
         * @param {CreateUpdatePrispevok} createUpdatePrispevok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePrispevokVestnika(createUpdatePrispevok: CreateUpdatePrispevok, options?: any): AxiosPromise<void> {
            return localVarFp.validatePrispevokVestnika(createUpdatePrispevok, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrispevokVestnikaAddApi - object-oriented interface
 * @export
 * @class PrispevokVestnikaAddApi
 * @extends {BaseAPI}
 */
export class PrispevokVestnikaAddApi extends BaseAPI {
    /**
     * Add prispevok vestnika
     * @param {CreateUpdatePrispevok} createUpdatePrispevok 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrispevokVestnikaAddApi
     */
    public addPrispevokVestnika(createUpdatePrispevok: CreateUpdatePrispevok, options?: RawAxiosRequestConfig) {
        return PrispevokVestnikaAddApiFp(this.configuration).addPrispevokVestnika(createUpdatePrispevok, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate prispevok vestnika in active step before create/update.
     * @param {CreateUpdatePrispevok} createUpdatePrispevok 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrispevokVestnikaAddApi
     */
    public validatePrispevokVestnika(createUpdatePrispevok: CreateUpdatePrispevok, options?: RawAxiosRequestConfig) {
        return PrispevokVestnikaAddApiFp(this.configuration).validatePrispevokVestnika(createUpdatePrispevok, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrispevokVestnikaDeleteApi - axios parameter creator
 * @export
 */
export const PrispevokVestnikaDeleteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete prispevok vestnika.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrispevokVestnika: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deletePrispevokVestnika', 'uuid', uuid)
            const localVarPath = `/prispevok-vestnika/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrispevokVestnikaDeleteApi - functional programming interface
 * @export
 */
export const PrispevokVestnikaDeleteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrispevokVestnikaDeleteApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete prispevok vestnika.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePrispevokVestnika(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePrispevokVestnika(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrispevokVestnikaDeleteApi.deletePrispevokVestnika']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrispevokVestnikaDeleteApi - factory interface
 * @export
 */
export const PrispevokVestnikaDeleteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrispevokVestnikaDeleteApiFp(configuration)
    return {
        /**
         * Delete prispevok vestnika.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrispevokVestnika(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePrispevokVestnika(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrispevokVestnikaDeleteApi - object-oriented interface
 * @export
 * @class PrispevokVestnikaDeleteApi
 * @extends {BaseAPI}
 */
export class PrispevokVestnikaDeleteApi extends BaseAPI {
    /**
     * Delete prispevok vestnika.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrispevokVestnikaDeleteApi
     */
    public deletePrispevokVestnika(uuid: string, options?: RawAxiosRequestConfig) {
        return PrispevokVestnikaDeleteApiFp(this.configuration).deletePrispevokVestnika(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrispevokVestnikaDetailApi - axios parameter creator
 * @export
 */
export const PrispevokVestnikaDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get detail of prispevok vestnika.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrispevokVestnikaDetail: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getPrispevokVestnikaDetail', 'uuid', uuid)
            const localVarPath = `/prispevok-vestnika/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrispevokVestnikaDetailApi - functional programming interface
 * @export
 */
export const PrispevokVestnikaDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrispevokVestnikaDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * Get detail of prispevok vestnika.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrispevokVestnikaDetail(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrispevokVestnikaDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrispevokVestnikaDetail(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrispevokVestnikaDetailApi.getPrispevokVestnikaDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrispevokVestnikaDetailApi - factory interface
 * @export
 */
export const PrispevokVestnikaDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrispevokVestnikaDetailApiFp(configuration)
    return {
        /**
         * Get detail of prispevok vestnika.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrispevokVestnikaDetail(uuid: string, options?: any): AxiosPromise<PrispevokVestnikaDetail> {
            return localVarFp.getPrispevokVestnikaDetail(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrispevokVestnikaDetailApi - object-oriented interface
 * @export
 * @class PrispevokVestnikaDetailApi
 * @extends {BaseAPI}
 */
export class PrispevokVestnikaDetailApi extends BaseAPI {
    /**
     * Get detail of prispevok vestnika.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrispevokVestnikaDetailApi
     */
    public getPrispevokVestnikaDetail(uuid: string, options?: RawAxiosRequestConfig) {
        return PrispevokVestnikaDetailApiFp(this.configuration).getPrispevokVestnikaDetail(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrispevokVestnikaInfoListApi - axios parameter creator
 * @export
 */
export const PrispevokVestnikaInfoListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get prispevky vestnika by vestnikUuid and hladanyNazov.
         * @param {string} uuid Primary key of entity
         * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrispevokVestnikaList: async (uuid: string, hladanyNazov?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getPrispevokVestnikaList', 'uuid', uuid)
            const localVarPath = `/prispevky-vestnika-info/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hladanyNazov !== undefined) {
                localVarQueryParameter['hladanyNazov'] = hladanyNazov;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrispevokVestnikaInfoListApi - functional programming interface
 * @export
 */
export const PrispevokVestnikaInfoListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrispevokVestnikaInfoListApiAxiosParamCreator(configuration)
    return {
        /**
         * Get prispevky vestnika by vestnikUuid and hladanyNazov.
         * @param {string} uuid Primary key of entity
         * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrispevokVestnikaList(uuid: string, hladanyNazov?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrispevokVestnikaInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrispevokVestnikaList(uuid, hladanyNazov, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrispevokVestnikaInfoListApi.getPrispevokVestnikaList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrispevokVestnikaInfoListApi - factory interface
 * @export
 */
export const PrispevokVestnikaInfoListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrispevokVestnikaInfoListApiFp(configuration)
    return {
        /**
         * Get prispevky vestnika by vestnikUuid and hladanyNazov.
         * @param {string} uuid Primary key of entity
         * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrispevokVestnikaList(uuid: string, hladanyNazov?: string, limit?: number, options?: any): AxiosPromise<Array<PrispevokVestnikaInfo>> {
            return localVarFp.getPrispevokVestnikaList(uuid, hladanyNazov, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrispevokVestnikaInfoListApi - object-oriented interface
 * @export
 * @class PrispevokVestnikaInfoListApi
 * @extends {BaseAPI}
 */
export class PrispevokVestnikaInfoListApi extends BaseAPI {
    /**
     * Get prispevky vestnika by vestnikUuid and hladanyNazov.
     * @param {string} uuid Primary key of entity
     * @param {string} [hladanyNazov] hladany nazov for ciselnik polozka.
     * @param {number} [limit] max number of results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrispevokVestnikaInfoListApi
     */
    public getPrispevokVestnikaList(uuid: string, hladanyNazov?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return PrispevokVestnikaInfoListApiFp(this.configuration).getPrispevokVestnikaList(uuid, hladanyNazov, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrispevokVestnikaListPageApi - axios parameter creator
 * @export
 */
export const PrispevokVestnikaListPageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get filtered prispevky vestnika list page.
         * @param {PrispevokVestnikaFilter} prispevokVestnikaFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrispevokVestnikaListPage: async (prispevokVestnikaFilter: PrispevokVestnikaFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prispevokVestnikaFilter' is not null or undefined
            assertParamExists('getPrispevokVestnikaListPage', 'prispevokVestnikaFilter', prispevokVestnikaFilter)
            const localVarPath = `/prispevky-vestnika`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prispevokVestnikaFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrispevokVestnikaListPageApi - functional programming interface
 * @export
 */
export const PrispevokVestnikaListPageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrispevokVestnikaListPageApiAxiosParamCreator(configuration)
    return {
        /**
         * Get filtered prispevky vestnika list page.
         * @param {PrispevokVestnikaFilter} prispevokVestnikaFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrispevokVestnikaListPage(prispevokVestnikaFilter: PrispevokVestnikaFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrispevokVestnikaListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrispevokVestnikaListPage(prispevokVestnikaFilter, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrispevokVestnikaListPageApi.getPrispevokVestnikaListPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrispevokVestnikaListPageApi - factory interface
 * @export
 */
export const PrispevokVestnikaListPageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrispevokVestnikaListPageApiFp(configuration)
    return {
        /**
         * Get filtered prispevky vestnika list page.
         * @param {PrispevokVestnikaFilter} prispevokVestnikaFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrispevokVestnikaListPage(prispevokVestnikaFilter: PrispevokVestnikaFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: any): AxiosPromise<PrispevokVestnikaListPage> {
            return localVarFp.getPrispevokVestnikaListPage(prispevokVestnikaFilter, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrispevokVestnikaListPageApi - object-oriented interface
 * @export
 * @class PrispevokVestnikaListPageApi
 * @extends {BaseAPI}
 */
export class PrispevokVestnikaListPageApi extends BaseAPI {
    /**
     * Get filtered prispevky vestnika list page.
     * @param {PrispevokVestnikaFilter} prispevokVestnikaFilter 
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrispevokVestnikaListPageApi
     */
    public getPrispevokVestnikaListPage(prispevokVestnikaFilter: PrispevokVestnikaFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig) {
        return PrispevokVestnikaListPageApiFp(this.configuration).getPrispevokVestnikaListPage(prispevokVestnikaFilter, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrispevokVestnikaPrilohaDownloadApi - axios parameter creator
 * @export
 */
export const PrispevokVestnikaPrilohaDownloadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Download priloha by uuid.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPriloha: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('downloadPriloha', 'uuid', uuid)
            const localVarPath = `/prispevky-vestnika/prilohy/{uuid}/download`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrispevokVestnikaPrilohaDownloadApi - functional programming interface
 * @export
 */
export const PrispevokVestnikaPrilohaDownloadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrispevokVestnikaPrilohaDownloadApiAxiosParamCreator(configuration)
    return {
        /**
         * Download priloha by uuid.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPriloha(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPriloha(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrispevokVestnikaPrilohaDownloadApi.downloadPriloha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrispevokVestnikaPrilohaDownloadApi - factory interface
 * @export
 */
export const PrispevokVestnikaPrilohaDownloadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrispevokVestnikaPrilohaDownloadApiFp(configuration)
    return {
        /**
         * Download priloha by uuid.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPriloha(uuid: string, options?: any): AxiosPromise<string> {
            return localVarFp.downloadPriloha(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrispevokVestnikaPrilohaDownloadApi - object-oriented interface
 * @export
 * @class PrispevokVestnikaPrilohaDownloadApi
 * @extends {BaseAPI}
 */
export class PrispevokVestnikaPrilohaDownloadApi extends BaseAPI {
    /**
     * Download priloha by uuid.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrispevokVestnikaPrilohaDownloadApi
     */
    public downloadPriloha(uuid: string, options?: RawAxiosRequestConfig) {
        return PrispevokVestnikaPrilohaDownloadApiFp(this.configuration).downloadPriloha(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrispevokVestnikaUpdateApi - axios parameter creator
 * @export
 */
export const PrispevokVestnikaUpdateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update prispevok vestnika.
         * @param {string} uuid Primary key of entity
         * @param {CreateUpdatePrispevok} createUpdatePrispevok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrispevokVestnika: async (uuid: string, createUpdatePrispevok: CreateUpdatePrispevok, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updatePrispevokVestnika', 'uuid', uuid)
            // verify required parameter 'createUpdatePrispevok' is not null or undefined
            assertParamExists('updatePrispevokVestnika', 'createUpdatePrispevok', createUpdatePrispevok)
            const localVarPath = `/prispevok-vestnika/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUpdatePrispevok, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrispevokVestnikaUpdateApi - functional programming interface
 * @export
 */
export const PrispevokVestnikaUpdateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrispevokVestnikaUpdateApiAxiosParamCreator(configuration)
    return {
        /**
         * Update prispevok vestnika.
         * @param {string} uuid Primary key of entity
         * @param {CreateUpdatePrispevok} createUpdatePrispevok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrispevokVestnika(uuid: string, createUpdatePrispevok: CreateUpdatePrispevok, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrispevokVestnika(uuid, createUpdatePrispevok, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrispevokVestnikaUpdateApi.updatePrispevokVestnika']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrispevokVestnikaUpdateApi - factory interface
 * @export
 */
export const PrispevokVestnikaUpdateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrispevokVestnikaUpdateApiFp(configuration)
    return {
        /**
         * Update prispevok vestnika.
         * @param {string} uuid Primary key of entity
         * @param {CreateUpdatePrispevok} createUpdatePrispevok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrispevokVestnika(uuid: string, createUpdatePrispevok: CreateUpdatePrispevok, options?: any): AxiosPromise<void> {
            return localVarFp.updatePrispevokVestnika(uuid, createUpdatePrispevok, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrispevokVestnikaUpdateApi - object-oriented interface
 * @export
 * @class PrispevokVestnikaUpdateApi
 * @extends {BaseAPI}
 */
export class PrispevokVestnikaUpdateApi extends BaseAPI {
    /**
     * Update prispevok vestnika.
     * @param {string} uuid Primary key of entity
     * @param {CreateUpdatePrispevok} createUpdatePrispevok 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrispevokVestnikaUpdateApi
     */
    public updatePrispevokVestnika(uuid: string, createUpdatePrispevok: CreateUpdatePrispevok, options?: RawAxiosRequestConfig) {
        return PrispevokVestnikaUpdateApiFp(this.configuration).updatePrispevokVestnika(uuid, createUpdatePrispevok, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get current logged user with defined roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/aktualny-pouzivatel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Get current logged user with defined roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Get current logged user with defined roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: any): AxiosPromise<UserDetail> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Get current logged user with defined roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }
}



